module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/exception_frame-c9adcefe0d52211a82ecb241e191b481.svg";